/** Standard page header: h5 title + subtitle + optional extra line. */
import { Box, Typography } from "@mui/material";
import type { ReactNode } from "react";

export function PageHeader({
  title,
  subtitle,
  extra,
}: {
  title: string;
  subtitle?: string;
  extra?: ReactNode;
}) {
  return (
    <Box>
      <Typography variant="h5" component="h1">
        {title}
      </Typography>
      {subtitle && <Typography variant="subtitle2">{subtitle}</Typography>}
      {extra}
    </Box>
  );
}
